import './aquarium-overview-stage.scss';

class Stage {
    constructor (element) {
        this.$stage = element;
        this.$content = this.$stage.querySelector('[data-stage="content"]');
        this.$stageContainer = this.$stage.querySelector('[data-stage="container"]');
        this.$stageMediaWrap = this.$stage.querySelector('[data-stage="media"]');
        this.$stageMedia = this.$stageMediaWrap.querySelector('img');
        this.doContentParallax = false;
        this.headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--siteheader-height').trim());
        this.observer = null;
        this.observerStartet = false;
        this.parallaxValues = {
            media: 0.25,
            content: 0.05
        };
    }

    initialize () {
        if (this.$stageMedia) {
            this.parallaxValues.media = parseInt(this.$stage.dataset.stageParallaxMedia) / 100;
            this.parallaxValues.content = parseInt(this.$stage.dataset.stageParallaxContent) / 100;

            this.setEvents();

            if (!window.mediaMatchHandler[1024].matches && this.$content) {
                this.doContentParallax = false;
            } else {
                this.doContentParallax = true;
            }

            if (this.$stageMedia && this.$stage.dataset.stageParallax !== undefined) {
                if (this.doContentParallax) {
                    this.setParallaxValue();
                    this.startObserver();
                }
            }
        }
    }

    setParallaxValue (remove = false) {
        const scrollPosition = window.scrollY;
        const stageMediaHeight = this.$stageMedia.offsetHeight;
        const topAdjustment = scrollPosition + this.$stageMediaWrap.getBoundingClientRect().top;

        if (this.$stageMediaWrap.getBoundingClientRect().top <= 0) {
            if (scrollPosition - (scrollPosition - this.$stageMediaWrap.getBoundingClientRect().top) > stageMediaHeight) {
                this.$stageMedia.style.transform = '';
                if (this.doContentParallax) {
                    this.$content.style.transform = '';
                }
                return;
            }

            this.$stageMedia.style.transform = `translateY(${(scrollPosition - (topAdjustment)) * this.parallaxValues.media}px)`;

            if (this.doContentParallax && this.parallaxValues.content !== 0) {
                this.$content.style.transform = `translateY(${(scrollPosition - (topAdjustment)) * this.parallaxValues.content}px)`;
            }

            if (remove) {
                this.$content.style.transform = '';
            }
        } else {
            this.$stageMedia.style.transform = '';
        }
    }

    startObserver () {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.addEventListener('scroll', handleParallax);
                } else {
                    window.removeEventListener('scroll', handleParallax);
                }
            });
        }, { threshold: 0 });

        this.observer.observe(this.$stageMedia);
        this.observerStartet = true;

        const handleParallax = () => {
            this.setParallaxValue();
        };
    }

    setEvents () {
        if (this.$stage.dataset.stageParallax !== undefined) {
            window.mediaMatchHandler[1024].addEventListener('change', (match) => {
                if (this.$content) {
                    if (match.matches) {
                        this.doContentParallax = true;

                        if (!this.observerStartet) {
                            this.startObserver();
                        }

                        this.setParallaxValue();
                    } else {
                        this.doContentParallax = false;
                        this.setParallaxValue(true);
                    }
                }
            });
        }
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$stages = $context.querySelectorAll('[data-stage="root"]');
        $$stages.forEach(($stage) => {
            const stage = new Stage($stage);
            stage.initialize();
        });
    }
});
